import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { setToken } from '../../../actions/authentication';
import { afterAuthRoute, loading } from '../../../actions/sessions';
import useSessionEntity from '../../../hooks/useSessionEntity';
import {
  formatPhoneNumber,
  normalizePhone,
} from '../../../lib/utils/formatters';
import Loading from '../../shared/Loading';
import ProgressBars from '../../shared/ProgressBars';
import Support from '../../shared/Support';
import UserTokenVerification from '../../shared/UserTokenVerification';

export default function PinVerification({ location, match }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const application = useSessionEntity('application');
  const isLoading = useSelector((state) => state.sessions.get('loading'));
  const exceededPhoneChanges = () => application?.phone_change_attempts >= 1;

  const tryAnotherOptionText = () => {
    if (!match.params.confirm && !exceededPhoneChanges()) {
      const url = `/${match.path.split('/')[1]}/phone`;
      return (
        <div className="flex flex-col xxs:flex-row items-center w-full my-5 xxs:mt-8 xxs:mb-6">
          <p className="font-light text-sm sm:text-lg">
            Didn't receive the code?
          </p>
          <Link
            to={url}
            className="ml-1 text-sm sm:text-lg text-primary-blue hover:text-primary-blue-hover"
          >
            Change Number
          </Link>
        </div>
      );
    }
  };

  const afterAuthCallback = (twofactor) => {
    return dispatch(afterAuthRoute(history, twofactor));
  };

  const onLockout = () => {
    history.push('/init/user_lockout');
  };

  const onNotBorrower = () => {
    history.push('/init/user_is_not_borrower');
  };

  const headerText = (
    <>
      {match.params.confirm
        ? 'We need to confirm your mobile phone'
        : `We just ${match.params.type === 'phone' ? 'texted' : 'emailed'} you`}
    </>
  );

  return (
    <div id="content" role="main" className="mx-6 sm:mx-auto">
      <ProgressBars />
      <div className="mt-4 mb-1 sm:mb-4">
        <div className="text-xl sm:text-4xl font-extrabold">{headerText}</div>
      </div>
      <div className="tracking-wide mb-6 font-light text-sm sm:text-lg">
        Please enter the verification code we sent to
        <span className="mx-1">
          {match.params.type === 'phone'
            ? formatPhoneNumber(normalizePhone(match.params.contact))
            : match.params.contact}
          .
        </span>
      </div>

      <div className="flex justify-start">
        <UserTokenVerification
          isLoading={isLoading}
          match={match}
          onAfterAuth={afterAuthCallback}
          onLoading={loading}
          onLockout={onLockout}
          onNotBorrower={onNotBorrower}
          onSaveToken={setToken}
          twofactor={true}
        >
          <Loading className="w-14 h-14" />
        </UserTokenVerification>
      </div>

      {tryAnotherOptionText()}

      <div className="mt-6 sm:mt-12">
        <Support />
      </div>
    </div>
  );
}
